import React from 'react';
import styled from 'styled-components';

const Span = styled.span`
font-size:20;
padding:10px;`
export default class PlayerGroupItem extends React.Component {


    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {

        //console.info('PlayerGroupItem - render called.', this.props);
        var playernames = [];
        var index = 0;
        var haslastitem = false;
        if (this.props.data.players) { }
        this.props.data.players.forEach(element => {
            element.key = index++;
            playernames.push(element.name);
            playernames.push(<br key={index++}></br>);
            if (element.currentEvent){
                haslastitem = true;
            }
        });

        
        let classname = haslastitem || this.props.haslastitem ? "playergroupitem_active":"playergroupitem";
        
        return (
            <div className={classname} onClick={() => this.props.onclick(this.props.data)}>

                <div style={{width:'50%', float:'left'}}>{playernames}</div>
                <div style={{width:'50%',float:'right'}}>{this.props.data.name}</div>
            </div>);
    }

}







// WEBPACK FOOTER //
// ./src/Components/Tournament/PlayerGroupItem.js